// extracted by mini-css-extract-plugin
export default {"wrapper":"WRz5LImIfmzqG5kjLmkh","header":"qogB6uc_HYJICMPMnwmB","title":"lEABzvXswwkqsbPomBRN","tabs":"jqOwoeWNCaiO3CBJBOCH"};